import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin( ScrollTrigger )

export default () => {
  let headerHeight = document.querySelector('header.main-header').clientHeight + 1;
  let actionNav = gsap.to('header.main-header', {y:`-=${headerHeight}`, duration:0.5, ease:'power2.in', paused:true});


  ScrollTrigger.create({
    trigger: "header.main-header",
    start: "100px top",
    end: 99999,
    onUpdate: ({progress, direction, isActive}) => {
      if (direction === -1) {
        actionNav.reverse()
      } if (direction === 1 ) {
        actionNav.play()
      } else if (direction === 1 && isActive === true) {
        actionNav.play()
      }
    }
  });

  $(".hamburger").click(function(){
    $('body').toggleClass("mobile-menu-active");
  });
}
